import React from 'react';

import DataRetentionConfigurationForm from './DataRetentionConfigurationForm';
import FormPage from 'src/presentation/components/pages/shared/FormPage';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import dataRetentionConfigurationResource from 'src/actions/dataRetention/dataRetentionConfigResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import { STATUS_LOADING } from 'src/presentation/hooks/useResource';

const DataRetentionConfiguration = () => {
  const { errors, loadingState, value } = useDocumentResource(dataRetentionConfigurationResource);

  const description = (
    <div data-aid="form-page-description">
      Configure customer data retention settings for your organization. By default, all customer data is retained
      forever. To learn more, see our{' '}
      <ExternalLink
        data-aid="compliance-guide"
        to="https://help.gladly.com/docs/configure-data-retention-settings-and-data-deletion-options"
        label="compliance guide"
      />
      .
    </div>
  );
  return (
    <FormPage
      data-aid="admin-data-retention-config-page"
      description={description}
      errors={errors}
      form={DataRetentionConfigurationForm}
      isLoading={loadingState === STATUS_LOADING}
      item={value}
      resetErrors={dataRetentionConfigurationResource.actions.resetErrors}
      title="Customer Data Retention"
    />
  );
};

export default DataRetentionConfiguration;
